import { INDIAN_STATES } from '../../../../../../Mandates/utils/constants'

export const FIELD_STATUS = {
  REQUIRED: 'required',
  OPTIONAL: 'optional',
  OFF: 'off',
}

export const RESPONSE_TYPES = [
  { label: 'Dropdown', value: 'DROPDOWN' },
  { label: 'Checkboxes', value: 'CHECKBOXES' },
  { label: 'Multiple Choice', value: 'MULTIPLE_CHOICE' },
  { label: 'Short Answer', value: 'SHORT_ANSWER' },
  { label: 'Paragraph', value: 'PARAGRAPH' },  
  { label: 'Date', value: 'DATE' },
  { label: 'Month-Year', value: 'MONTH_YEAR' },
  { label: 'File Upload', value: 'FILE_UPLOAD' },
]

export const getResponseTypeLabel = (value) => {
  const type = RESPONSE_TYPES.find(t => t.value === value)
  return type ? type.label : value
}

export const VALIDATIONS = {
  EMAIL: 'EMAIL',
  MOBILE: 'MOBILE',
  PINCODE: 'PINCODE',
  MARKS_PERCENT: 'MARKS_PERCENT',
  ARREARS: 'ARREARS',
  NUMBER: 'NUMBER',
  NO_NUMBERS: 'NO_NUMBERS',
}

export const STATE_OPTIONS = [...INDIAN_STATES]
export const GOVT_PRIVATE_OPTIONS = ['Government', 'Private']

export const getYearOptions = () => {
  const currentYear = new Date().getFullYear()
  const years = []
  for (let y = currentYear - 15; y <= currentYear + 5; y += 1) {
    years.push(String(y))
  }
  return years
}

export const VALIDATION_RULES = {
  [VALIDATIONS.EMAIL]: { type: 'email', placeholder: 'name@example.com' },
  [VALIDATIONS.MOBILE]: { type: 'tel', inputMode: 'numeric', maxLength: 10, minLength: 10, pattern: '[0-9]{10}', placeholder: '10-digit mobile number' },
  [VALIDATIONS.PINCODE]: { type: 'text', inputMode: 'numeric', maxLength: 6, minLength: 6, pattern: '[0-9]{6}', placeholder: '6-digit pincode' },
  [VALIDATIONS.MARKS_PERCENT]: { type: 'number', min: 0, max: 100, step: 0.01, placeholder: '0.00 – 100.00' },
  [VALIDATIONS.ARREARS]: { type: 'number', min: 0, max: 40, step: 1, placeholder: '0 – 40' },
  [VALIDATIONS.NUMBER]: { type: 'number', min: 0, step: 'any', placeholder: 'Enter a number' },
  [VALIDATIONS.NO_NUMBERS]: { type: 'text', pattern: '[A-Za-z\\s./&-]+', placeholder: 'Letters only' },
}

const BASIC_INFO_FIELDS = [
  { id: 'q0', question: 'Upload CV (PDF)', responseType: 'FILE_UPLOAD', status: 'optional', options: [] },
  { id: 'q1', question: 'First Name', responseType: 'SHORT_ANSWER', status: 'required', options: [] },
  { id: 'q2', question: 'Last Name', responseType: 'SHORT_ANSWER', status: 'required', options: [] },
  { id: 'q3', question: 'Date of Birth', responseType: 'DATE', status: 'required', options: [] },
  { id: 'q4', question: 'Gender', responseType: 'MULTIPLE_CHOICE', status: 'required', options: ['Male', 'Female', 'Others'] },
  { id: 'q5', question: 'Primary Email Address', responseType: 'SHORT_ANSWER', status: 'required', options: [], validation: VALIDATIONS.EMAIL },
  { id: 'q6', question: 'Secondary Email Address', responseType: 'SHORT_ANSWER', status: 'optional', options: [], validation: VALIDATIONS.EMAIL },
  { id: 'q7', question: 'Mobile Number', responseType: 'SHORT_ANSWER', status: 'required', options: [], validation: VALIDATIONS.MOBILE },
  { id: 'q8', question: 'Alternative Mobile Number', responseType: 'SHORT_ANSWER', status: 'optional', options: [], validation: VALIDATIONS.MOBILE },
  { id: 'q9', question: 'Permanent Address - State', responseType: 'DROPDOWN', status: 'required', options: STATE_OPTIONS },
  { id: 'q10', question: 'Permanent Address - City', responseType: 'SHORT_ANSWER', status: 'required', options: [] },
  { id: 'q11', question: 'Permanent Address - Pincode', responseType: 'SHORT_ANSWER', status: 'required', options: [], validation: VALIDATIONS.PINCODE },
  { id: 'q12', question: 'Current Address - State', responseType: 'DROPDOWN', status: 'required', options: STATE_OPTIONS },
  { id: 'q13', question: 'Current Address - City', responseType: 'SHORT_ANSWER', status: 'required', options: [] },
  { id: 'q14', question: 'Current Address - Pincode', responseType: 'SHORT_ANSWER', status: 'required', options: [], validation: VALIDATIONS.PINCODE },
]

const DIPLOMA_EDU_FIELDS = [
  { id: 'q15', question: '10th - Year', responseType: 'DROPDOWN', status: 'required', options: getYearOptions() },
  { id: 'q16', question: '10th - Marks (In %)', responseType: 'SHORT_ANSWER', status: 'required', options: [], validation: VALIDATIONS.MARKS_PERCENT },
  { id: 'q17', question: '12th - Year', responseType: 'DROPDOWN', status: 'optional', options: getYearOptions() },
  { id: 'q18', question: '12th - Marks (In %)', responseType: 'SHORT_ANSWER', status: 'optional', options: [], validation: VALIDATIONS.MARKS_PERCENT },
  { id: 'q19', question: 'Diploma - College name', responseType: 'SHORT_ANSWER', status: 'required', options: [] },
  { id: 'q20', question: 'Diploma - City', responseType: 'SHORT_ANSWER', status: 'required', options: [] },
  { id: 'q27', question: 'Diploma - State', responseType: 'DROPDOWN', status: 'required', options: STATE_OPTIONS },
  { id: 'q28', question: 'Diploma - Government / Private', responseType: 'DROPDOWN', status: 'required', options: GOVT_PRIVATE_OPTIONS },
  { id: 'q21', question: 'Diploma - Degree', responseType: 'SHORT_ANSWER', status: 'required', options: [], validation: VALIDATIONS.NO_NUMBERS },
  { id: 'q22', question: 'Diploma - Department/Trade', responseType: 'SHORT_ANSWER', status: 'required', options: [], validation: VALIDATIONS.NO_NUMBERS },
  { id: 'q23', question: 'Diploma - End Year', responseType: 'DROPDOWN', status: 'required', options: getYearOptions() },
  { id: 'q24', question: 'Diploma - Marks (In %)', responseType: 'SHORT_ANSWER', status: 'required', options: [], validation: VALIDATIONS.MARKS_PERCENT },
  { id: 'q25', question: 'Diploma - No. of Current arrears/Backlogs/KT', responseType: 'SHORT_ANSWER', status: 'required', options: [], validation: VALIDATIONS.ARREARS },
  { id: 'q26', question: 'Diploma - No. of Past Arrears/Backlogs/KT', responseType: 'SHORT_ANSWER', status: 'required', options: [], validation: VALIDATIONS.ARREARS },
]

const ITI_EDU_FIELDS = [
  { id: 'q15', question: 'ITI - College name', responseType: 'SHORT_ANSWER', status: 'required', options: [] },
  { id: 'q16', question: 'ITI - City', responseType: 'SHORT_ANSWER', status: 'required', options: [] },
  { id: 'q23', question: 'ITI - State', responseType: 'DROPDOWN', status: 'required', options: STATE_OPTIONS },
  { id: 'q17', question: 'ITI - Degree', responseType: 'SHORT_ANSWER', status: 'required', options: [], validation: VALIDATIONS.NO_NUMBERS },
  { id: 'q18', question: 'ITI - Department/Trade', responseType: 'SHORT_ANSWER', status: 'required', options: [], validation: VALIDATIONS.NO_NUMBERS },
  { id: 'q19', question: 'ITI - End Year', responseType: 'DROPDOWN', status: 'required', options: getYearOptions() },
  { id: 'q20', question: 'ITI - Marks (in %)', responseType: 'SHORT_ANSWER', status: 'required', options: [], validation: VALIDATIONS.MARKS_PERCENT },
  { id: 'q21', question: 'ITI - No. of Current arrears/Backlogs/KT', responseType: 'SHORT_ANSWER', status: 'required', options: [], validation: VALIDATIONS.ARREARS },
  { id: 'q22', question: 'ITI - No. of Past Arrears/Backlogs/KT', responseType: 'SHORT_ANSWER', status: 'required', options: [], validation: VALIDATIONS.ARREARS },
]

const OFF_CAMPUS_FRESHER_BASIC_FIELDS = [
  { id: 'oc_b1', question: 'Upload CV (PDF)', responseType: 'FILE_UPLOAD', status: 'optional', options: [] },
  { id: 'oc_b2', question: 'First Name', responseType: 'SHORT_ANSWER', status: 'required', options: [] },
  { id: 'oc_b3', question: 'Last Name', responseType: 'SHORT_ANSWER', status: 'required', options: [] },
  { id: 'oc_b4', question: 'Date of Birth', responseType: 'DATE', status: 'required', options: [] },
  { id: 'oc_b5', question: 'Gender', responseType: 'MULTIPLE_CHOICE', status: 'required', options: ['Male', 'Female', 'Others'] },
  { id: 'oc_b6', question: 'Primary Email Address', responseType: 'SHORT_ANSWER', status: 'required', options: [], validation: VALIDATIONS.EMAIL },
  { id: 'oc_b7', question: 'Mobile Number', responseType: 'SHORT_ANSWER', status: 'required', options: [], validation: VALIDATIONS.MOBILE },
  { id: 'oc_b8', question: 'Permanent Address - State', responseType: 'DROPDOWN', status: 'required', options: STATE_OPTIONS },
  { id: 'oc_b9', question: 'Permanent Address - City', responseType: 'SHORT_ANSWER', status: 'required', options: [] },
  { id: 'oc_b10', question: 'Permanent Address - Pincode', responseType: 'SHORT_ANSWER', status: 'required', options: [], validation: VALIDATIONS.PINCODE },
  { id: 'oc_b11', question: 'Current Address - State', responseType: 'DROPDOWN', status: 'required', options: STATE_OPTIONS },
  { id: 'oc_b12', question: 'Current Address - City', responseType: 'SHORT_ANSWER', status: 'required', options: [] },
  { id: 'oc_b13', question: 'Current Address - Pincode', responseType: 'SHORT_ANSWER', status: 'required', options: [], validation: VALIDATIONS.PINCODE },
]

const OFF_CAMPUS_FRESHER_EDU_FIELDS = [
  { id: 'oc_e1', question: '10th - Year', responseType: 'DROPDOWN', status: 'required', options: getYearOptions() },
  { id: 'oc_e2', question: '10th - Marks (In %)', responseType: 'SHORT_ANSWER', status: 'required', options: [], validation: VALIDATIONS.MARKS_PERCENT },
  { id: 'oc_e3', question: '12th - Year', responseType: 'DROPDOWN', status: 'optional', options: getYearOptions() },
  { id: 'oc_e4', question: '12th - Marks (In %)', responseType: 'SHORT_ANSWER', status: 'optional', options: [], validation: VALIDATIONS.MARKS_PERCENT },
  { id: 'oc_e5', question: 'UG - State', responseType: 'DROPDOWN', status: 'required', options: STATE_OPTIONS },
  { id: 'oc_e6', question: 'UG - City', responseType: 'SHORT_ANSWER', status: 'required', options: [] },
  { id: 'oc_e7', question: 'UG - Govt / Pvt', responseType: 'DROPDOWN', status: 'required', options: GOVT_PRIVATE_OPTIONS },
  { id: 'oc_e8', question: 'UG - College Name', responseType: 'SHORT_ANSWER', status: 'required', options: [], placeholder: 'e.g. Anna University, Chennai' },
  { id: 'oc_e9', question: 'UG - Degree', responseType: 'SHORT_ANSWER', status: 'required', options: [], validation: VALIDATIONS.NO_NUMBERS, placeholder: 'e.g. B.E., B.Tech, B.Sc' },
  { id: 'oc_e10', question: 'UG - Department / Specialisation', responseType: 'SHORT_ANSWER', status: 'required', options: [], validation: VALIDATIONS.NO_NUMBERS, placeholder: 'e.g. Computer Science' },
  { id: 'oc_e11', question: 'UG - Year of Passing', responseType: 'DROPDOWN', status: 'required', options: getYearOptions(), placeholder: 'Select year' },
  { id: 'oc_e12', question: 'UG - Marks (In %)', responseType: 'SHORT_ANSWER', status: 'required', options: [], validation: VALIDATIONS.MARKS_PERCENT },
  { id: 'oc_e13', question: 'UG - No. of Current Arrears/Backlogs', responseType: 'SHORT_ANSWER', status: 'required', options: [], validation: VALIDATIONS.ARREARS },
  { id: 'oc_e14', question: 'UG - No. of Past Arrears/Backlogs', responseType: 'SHORT_ANSWER', status: 'required', options: [], validation: VALIDATIONS.ARREARS },
]

const OFF_CAMPUS_FRESHER_PG_FIELDS = [
  { id: 'oc_p1', question: 'PG - State', responseType: 'DROPDOWN', status: 'optional', options: STATE_OPTIONS },
  { id: 'oc_p2', question: 'PG - City', responseType: 'SHORT_ANSWER', status: 'optional', options: [] },
  { id: 'oc_p3', question: 'PG - College Name', responseType: 'SHORT_ANSWER', status: 'optional', options: [], placeholder: 'e.g. IIM Bangalore' },
  { id: 'oc_p4', question: 'PG - Degree', responseType: 'SHORT_ANSWER', status: 'optional', options: [], validation: VALIDATIONS.NO_NUMBERS, placeholder: 'e.g. M.Tech, MBA' },
  { id: 'oc_p5', question: 'PG - Department / Specialisation', responseType: 'SHORT_ANSWER', status: 'optional', options: [], validation: VALIDATIONS.NO_NUMBERS, placeholder: 'e.g. Finance, Data Science' },
  { id: 'oc_p6', question: 'PG - Year of Passing', responseType: 'DROPDOWN', status: 'optional', options: getYearOptions(), placeholder: 'Select year' },
  { id: 'oc_p7', question: 'PG - Marks (In %)', responseType: 'SHORT_ANSWER', status: 'optional', options: [], validation: VALIDATIONS.MARKS_PERCENT },
  { id: 'oc_p8', question: 'PG - No. of Current Arrears/Backlogs', responseType: 'SHORT_ANSWER', status: 'optional', options: [], validation: VALIDATIONS.ARREARS },
  { id: 'oc_p9', question: 'PG - No. of Past Arrears/Backlogs', responseType: 'SHORT_ANSWER', status: 'optional', options: [], validation: VALIDATIONS.ARREARS },
]

const EXPERIENCED_BASIC_FIELDS = [
  { id: 'ex_b1', question: 'Upload CV (PDF)', responseType: 'FILE_UPLOAD', status: 'optional', options: [] },
  { id: 'ex_b2', question: 'First Name', responseType: 'SHORT_ANSWER', status: 'required', options: [] },
  { id: 'ex_b3', question: 'Last Name', responseType: 'SHORT_ANSWER', status: 'required', options: [] },
  { id: 'ex_b4', question: 'Date of Birth', responseType: 'DATE', status: 'required', options: [] },
  { id: 'ex_b5', question: 'Gender', responseType: 'MULTIPLE_CHOICE', status: 'required', options: ['Male', 'Female', 'Others'] },
  { id: 'ex_b6', question: 'Primary Email Address', responseType: 'SHORT_ANSWER', status: 'required', options: [], validation: VALIDATIONS.EMAIL },
  { id: 'ex_b7', question: 'Mobile Number', responseType: 'SHORT_ANSWER', status: 'required', options: [], validation: VALIDATIONS.MOBILE },
  { id: 'ex_b11', question: 'Permanent Address - State', responseType: 'DROPDOWN', status: 'required', options: STATE_OPTIONS },
  { id: 'ex_b12', question: 'Permanent Address - City', responseType: 'SHORT_ANSWER', status: 'required', options: [] },
  { id: 'ex_b13', question: 'Permanent Address - Pincode', responseType: 'SHORT_ANSWER', status: 'required', options: [], validation: VALIDATIONS.PINCODE },
  { id: 'ex_b8', question: 'Current Address - State', responseType: 'DROPDOWN', status: 'required', options: STATE_OPTIONS },
  { id: 'ex_b9', question: 'Current Address - City', responseType: 'SHORT_ANSWER', status: 'required', options: [] },
  { id: 'ex_b10', question: 'Current Address - Pincode', responseType: 'SHORT_ANSWER', status: 'required', options: [], validation: VALIDATIONS.PINCODE },
]

const EXPERIENCED_EDU_FIELDS = [
  { id: 'ex_e1', question: 'UG - College Name', responseType: 'SHORT_ANSWER', status: 'required', options: [], placeholder: 'e.g. Anna University, Chennai' },
  { id: 'ex_e2', question: 'UG - Degree', responseType: 'SHORT_ANSWER', status: 'required', options: [], validation: VALIDATIONS.NO_NUMBERS, placeholder: 'e.g. B.E., B.Tech, B.Sc' },
  { id: 'ex_e3', question: 'UG - Department / Specialisation', responseType: 'SHORT_ANSWER', status: 'required', options: [], validation: VALIDATIONS.NO_NUMBERS, placeholder: 'e.g. Computer Science' },
  { id: 'ex_e4', question: 'UG - Year of Passing', responseType: 'DROPDOWN', status: 'required', options: getYearOptions(), placeholder: 'Select year' },
  { id: 'ex_e5', question: 'PG - College Name', responseType: 'SHORT_ANSWER', status: 'optional', options: [], placeholder: 'e.g. IIM Bangalore' },
  { id: 'ex_e6', question: 'PG - Degree', responseType: 'SHORT_ANSWER', status: 'optional', options: [], validation: VALIDATIONS.NO_NUMBERS, placeholder: 'e.g. M.Tech, MBA' },
  { id: 'ex_e7', question: 'PG - Department / Specialisation', responseType: 'SHORT_ANSWER', status: 'optional', options: [], validation: VALIDATIONS.NO_NUMBERS, placeholder: 'e.g. Finance, Data Science' },
  { id: 'ex_e8', question: 'PG - Year of Passing', responseType: 'DROPDOWN', status: 'optional', options: getYearOptions(), placeholder: 'Select year' },
]

const EXPERIENCED_WORK_FIELDS = [
  { id: 'ex_w1', question: 'Current/Last Role Title', responseType: 'SHORT_ANSWER', status: 'required', options: [], placeholder: 'e.g. Software Engineer' },
  { id: 'ex_w2', question: 'Current/Last Company Name', responseType: 'SHORT_ANSWER', status: 'required', options: [], placeholder: 'e.g. Infosys Ltd.' },
  { id: 'ex_w3', question: 'Start Month-Year', responseType: 'MONTH_YEAR', status: 'required', options: [], placeholder: 'MMM YYYY (e.g. Jan 2022)' },
  { id: 'ex_w4', question: 'End Month-Year', responseType: 'MONTH_YEAR', status: 'required', options: [], placeholder: 'MMM YYYY (e.g. Dec 2024)' },
  { id: 'ex_w5', question: 'Total Years of Experience', responseType: 'SHORT_ANSWER', status: 'required', options: [], validation: VALIDATIONS.NUMBER, placeholder: 'e.g. 3.5' },
  { id: 'ex_w6', question: 'Current CTC (LPA)', responseType: 'SHORT_ANSWER', status: 'required', options: [], validation: VALIDATIONS.NUMBER, placeholder: 'e.g. 6.5' },
  { id: 'ex_w7', question: 'Industry', responseType: 'SHORT_ANSWER', status: 'optional', options: [], placeholder: 'e.g. IT Services, Manufacturing' },
]

export const getSectionsByType = (type) => {
  switch (type) {
    case 'ITI':
      return [
        { id: 'basicInfo', title: 'Basic Info', fields: BASIC_INFO_FIELDS.map(f => ({ ...f })) },
        { id: 'educationalDetails', title: 'Educational Details', fields: ITI_EDU_FIELDS.map(f => ({ ...f })) },
      ]
    case 'OFF_CAMPUS_FRESHER':
      return [
        { id: 'basicInfo', title: 'Basic Info', fields: OFF_CAMPUS_FRESHER_BASIC_FIELDS.map(f => ({ ...f })) },
        { id: 'educationalDetails', title: 'Educational Details', fields: OFF_CAMPUS_FRESHER_EDU_FIELDS.map(f => ({ ...f })) },
        { id: 'pgDetails', title: 'PG Details (Optional)', fields: OFF_CAMPUS_FRESHER_PG_FIELDS.map(f => ({ ...f })) },
      ]
    case 'EXPERIENCED':
      return [
        { id: 'basicInfo', title: 'Basic Info', fields: EXPERIENCED_BASIC_FIELDS.map(f => ({ ...f })) },
        { id: 'educationalDetails', title: 'Educational Details', fields: EXPERIENCED_EDU_FIELDS.map(f => ({ ...f })) },
        { id: 'workExperience', title: 'Work Experience', fields: EXPERIENCED_WORK_FIELDS.map(f => ({ ...f })) },
      ]
    case 'OFF_CAMPUS_BOTH':
      return [
        { id: 'basicInfo', title: 'Basic Info', fields: OFF_CAMPUS_FRESHER_BASIC_FIELDS.map(f => ({ ...f })) },
        { id: 'educationalDetails', title: 'Educational Details', fields: OFF_CAMPUS_FRESHER_EDU_FIELDS.map(f => ({ ...f })) },
        { id: 'pgDetails', title: 'PG Details (Optional)', fields: OFF_CAMPUS_FRESHER_PG_FIELDS.map(f => ({ ...f })) },
        { id: 'workExperience', title: 'Work Experience (If Applicable)', fields: EXPERIENCED_WORK_FIELDS.map(f => ({ ...f, status: f.status === 'required' ? 'optional' : f.status })) },
      ]
    case 'DIPLOMA':
    default:
      return [
        { id: 'basicInfo', title: 'Basic Info', fields: BASIC_INFO_FIELDS.map(f => ({ ...f })) },
        { id: 'educationalDetails', title: 'Educational Details', fields: DIPLOMA_EDU_FIELDS.map(f => ({ ...f })) },
      ]
  }
}

export const sectionsToFormik = (sections) => {
  const allFields = []
  sections.forEach(section => {
    section.fields.forEach(field => {
      if (field.status !== 'off') {
        allFields.push({
          id: field.id,
          question: field.question,
          responseType: field.responseType,
          required: field.status === 'required',
          options: field.options || [],
          ...(field.validation ? { validation: field.validation } : {}),
          ...(field.placeholder ? { placeholder: field.placeholder } : {}),
        })
      }
    })
  })
  return allFields
}

export const formikToSections = (mandatoryQuestions, templateType) => {
  const defaultSections = getSectionsByType(templateType)
  if (!mandatoryQuestions || mandatoryQuestions.length === 0) {
    return defaultSections
  }
  return defaultSections.map(section => ({
    ...section,
    fields: section.fields.map(field => {
      const saved = mandatoryQuestions.find(q => q.id === field.id)
      if (saved) {
        return {
          ...field,
          question: saved.question,
          responseType: saved.responseType,
          status: saved.required ? 'required' : 'optional',
          options: saved.options && saved.options.length > 0 ? saved.options : field.options,
          validation: saved.validation || field.validation,
          placeholder: saved.placeholder || field.placeholder,
        }
      }
      return { ...field, status: 'off' }
    }),
  }))
}

export const getTemplateByType = (type) => {
  const sections = getSectionsByType(type)
  return sectionsToFormik(sections)
}
